<ion-app>
    @if (isAuthenticated()) {
        <ion-menu side="end" menuId="profile-menu" contentId="main-content">
            <ion-header>
                <ion-toolbar>
                    <ion-buttons slot="start" >
                        <ion-menu-toggle menu="profile-menu">
                            <ion-button>
                                <ion-icon name="close-outline" color="light" size="large"></ion-icon>
                            </ion-button>
                        </ion-menu-toggle>
                    </ion-buttons>
                    <ion-title>{{ 'menu.title' | translate }}</ion-title>
                </ion-toolbar>
            </ion-header>
            <ion-content class="profile-menu">
                <ion-list>
                    <ion-menu-toggle auto-hide="false">
                        <ion-item class="custom-height" (click)="openHome()">
                            <ion-label>{{ 'menu.home' | translate }}</ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                    <ion-menu-toggle auto-hide="false">
                        <ion-item class="custom-height" (click)="openProfile()">
                            <ion-label>{{ 'menu.profile' | translate }}</ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                    <ion-menu-toggle auto-hide="false">
                        <ion-item class="custom-height" (click)="openAbsence()">
                            <ion-label>{{ 'menu.absence' | translate }}</ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                    <ion-menu-toggle auto-hide="false">
                        <ion-item>
                            <ion-label>
                                <ion-button id="open-logout-sheet" color="danger">{{ 'menu.logout' | translate }}</ion-button>
                                <ion-action-sheet trigger="open-logout-sheet" [header]="'menu.logout_header' | translate"
                                                  [buttons]="logoutSheetButtons" (didDismiss)="onLogoutSheetDismissed($event)"></ion-action-sheet>
                            </ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                </ion-list>
            </ion-content>
        </ion-menu>
    }

  <ion-router-outlet id="main-content"></ion-router-outlet>

  @if (showPermissionModal()) {
    <app-push-permission-modal (permissionRequested)="onPermissionRequested()"
                               (closeModal)="closePermissionModal()"></app-push-permission-modal>
  }
</ion-app>
